module.exports = __webpack_public_path__ + "img/关于我们顶图.c58f3b3a.png";